export default function({ redirect, route }) {
  const isMaintenance = /^true$/i.test(process.env.MAINTENANCE)
  if (isMaintenance) {
    return redirect('/maintenance')
  }
  if (isMaintenance === false && route.path === '/maintenance') {
    return redirect('/')
  }
}
